<template>
  <div class="menu-icon" :class="{'menu-icon--active':drawer}" @click.stop="onTap">
    <span class="menu-icon__bars">
      <span class="menu-icon__bars-top" :class="{'menu-icon__bars-top--active':drawer}" />
      <span class="menu-icon__bars-center" :class="{'menu-icon__bars-center--active':drawer}" />
      <span class="menu-icon__bars-bottom" :class="{'menu-icon__bars-bottom--active':drawer}" />
    </span>
    MENU
  </div>
</template>

<script>
export default {
  methods: {
    onTap() {
      this.$store.commit("setDrawer", { drawer: !this.drawer });
    },
  },

  computed: {
    drawer() {
      return this.$store.state.drawer;
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-icon
  width 72px
  height 100%
  font-size 16px
  line-height 1.0
  padding-top 42px

  position absolute
  left 0
  top 0
  // background #072070
  background-image linear-gradient(to top right, rgba(0,7,71,.8), rgba(5,80,166,.9))
  cursor pointer
  text-align center
  color #ffffff
  font-weight bold
  transition all 0.3s
  font-feature-settings: "palt"
  font-family -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Original Yu Gothic", "Yu Gothic", YuGothic, Verdana, Meiryo, "M+ 1p", sans-serif

  &--active
    background #e3e7eb
    color #072070

  &__bars
    position absolute
    width 28px
    height 16px
    left calc(50% - 14px)
    top 16px

    &-top
      position absolute
      left calc(50% - 14px)
      top 0px
      width 28px
      height 1px
      position absolute
      overflow hidden
      background #ffffff
      transition all 0.5s
      box-sizing border-box

      &--active
        background-color #072070
        transform translateY(8px) rotate(-45deg)
        transition 0.4s ease


    &-center
      position absolute
      left calc(50% - 14px)
      top 50%
      width 28px
      height 1px
      position absolute
      overflow hidden
      background #ffffff
      transition all 0.5s
      box-sizing border-box

      &--active
        transition 0.4s ease
        opacity 0

    &-bottom
      position absolute
      left calc(50% - 14px)
      top 100%
      width 28px
      height 1px
      position absolute
      overflow hidden
      background #ffffff
      transition all 0.5s
      box-sizing border-box

      &--active
        background-color #072070
        transform translateY(-8px) rotate(45deg)
        transition 0.4s ease
</style>
